module.exports = __webpack_public_path__ + "static/media/Acrilico (32).85a22490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (32).jpg
// module id = 300
// module chunks = 0